import { albertineProfileConfig } from "./albertine";
import type { ProfileConfig } from "./types";

// TODO(tenant): Mirrors Albertine until Revolut has its own configuration.
export const revolutProfileConfig: ProfileConfig = albertineProfileConfig;
